// SPEC_DEMO.md PR-5 + Implementation Notes → Telemetry.
//
// One-function stub. Emits console.info; nothing leaves the browser.
// Swap the implementation later (PostHog / Segment / GA / nothing) by
// editing only this file — call sites are stable.
//
// Hard rules:
//   - No PII (no email, no name, no IP, no geolocation).
//   - No session IDs, no localStorage, no cookies.
//   - Drop the call entirely if you can't satisfy both. Conversion
//     analysis lives on the marketing site, not in the demo bundle.

export function track(event, payload = undefined) {
  // Prefix so prod-noise filtering is easy in DevTools.
  if (payload === undefined) {
    console.info('[demo-telemetry]', event);
  } else {
    console.info('[demo-telemetry]', event, payload);
  }
}

export default { track };
